const GeminiIcon = (props) => (
  <svg
    viewBox="0 0 24 24"
    fill="currentColor"
    height="1em"
    width="1em"
    {...props}
  >
    {/* Example SVG path - Replace with Gemini logo path */}
    <path d="M5 3v18h2V3H5zm12 0v18h2V3h-2zM8 5v2h8V5H8zm0 12v2h8v-2H8z" />
  </svg>
);
export default GeminiIcon;
